var e={Undefined:"Undefined",Enabled:"Enabled",Disabled:"Disabled"},a={Enable:"Enable",Disable:"Disable"};export{a as GasPipelineSectionAction,e as GasPipelineSectionStatus};
//# sourceMappingURL=types.js.map